(function() {

function loadSnippets(snippets) {
  return tb.ajax.loadSnippets(snippets).then(function(snippets) {
    for(let key in snippets)
      snippets[key] = snippets[key].prop("outerHTML");
    return snippets;
  });
}

var oneTime = tb.dom.oneTime,
  trimHtml = tb.dom.trimHtml,
  debounce = tb.common.debounce,
  hookAjaxDone = tb.hooks.hookAfterAjaxDone,
  slugify = tb.common.slugify;

function ajaxGetSafe(url) {
  return tb.ajax.loadFragment(url, true);
}

function hookBeforeShoptetFn(name, callback) {
  document.addEventListener(name, function() {
  var args = shoptet.scripts.arguments[name];
      callback.apply(null, args);
  });
}

function legacyLoadSnippets(urls, callback) {
  tb.ajax.loadSnippets(urls).then(function(snippets) {
    return waitForModules().then(function() { return snippets; });
  }).then(function(snippets) {
    callback.apply(null, snippets.map(function($snippet) {
        return [ tb.$h("div", $snippet).html() ];
    }));
  });
}

function oneTime($el) {
  $el = $($el);
  if($el.data("tplInitialized"))
    return false;
  $el.data("tplInitialized", true);
  return true;
}

function trimHtml($el) {
  return $($el).each(function() {
    $(this).html($(this).html().trim());
  });
}

function debounce(func, wait) {
  var lastCall = 0;

  return function() {
    var now = Date.now();
    if(now - lastCall < wait)
      return;
    lastCall = now;
    func.apply({}, arguments);
  };
}

var hooks = (function(global) {
  function getProperty(obj, path) {
    return path.split(".").reduce(function(cur, key) {
      if(cur === undefined)
        return cur;
      return cur[key];
    }, obj);
  }

  function setProperty(obj, path, value) {
    var parts = path.split("."), key;
    while(key = parts.shift()) {
      if(!parts.length) // key is last
        obj[key] = value;
      else
        obj = obj[key];
    }
  }

  function hookFn(nameOrFn, callback) {
    var origFn = typeof nameOrFn === "string" ? getProperty(global, nameOrFn) : nameOrFn;
    if(typeof origFn !== "function")
      throw new Error(nameOrFn + " is not a function");

    function patchedFn() {
      return callback(origFn, arguments, this);
    };
    if(typeof nameOrFn === "string")
      setProperty(global, nameOrFn, patchedFn);
    return patchedFn;
  }

  function hookBeforeShoptetFn(name, callback) {
    document.addEventListener(name, function() {
      var args = shoptet.scripts.arguments[name];
      callback.apply(null, args);
    });
  }

  function hookAfterShoptetFn(name, callback) {
    var oldCallback = shoptet.scripts.customCallbacks[name];
    if(!oldCallback)
      oldCallback = function noop() {}

    shoptet.scripts.customCallbacks[name] = function(args) {
      oldCallback(args);
      callback(args);
    };
  }

  function hookAfterAjaxDone(url, callback) {
    hookFn("$.ajax", function(oldAjax, args, context) {
      var options = args[0], ajaxResult = oldAjax.apply(context, args);
      if(options.url === url) {
        ajaxResult.done = hookFn(ajaxResult.done, function(oldDone, args, context) {
          args = [].slice.call(args);
          args.push(callback);
          return oldDone.apply(context, args);
        });
      }
      return ajaxResult;
    });
  }

  return {
    hookFn: hookFn,
    hookBeforeShoptetFn: hookBeforeShoptetFn,
    hookAfterShoptetFn: hookAfterShoptetFn,
    hookAfterAjaxDone: hookAfterAjaxDone
  };
})(window);

function mobileSlick($el, options) {
  $el = $($el);
  var oldVisible = null;
  function resizeHandler() {
    var visible = $(window).width() < 767;
    if(visible === oldVisible)
      return;
    if(visible)
      $el.slick(options);
    else if(oldVisible)
      $el.slick("destroy");
    oldVisible = visible;
  }
  $(window).resize(resizeHandler);
  resizeHandler();
}

var ajax = tb.ajax;
var ajaxGetSafe = tb.ajax.loadFragment;

function slugify(str) {
  var letters = str.trim()
    .toLowerCase()
    .split(""); // Split to array of letters

  var transFrom = "ěščřžýáíéďťóúůňďť";
  var transTo   = "escrzyaiedtouundt";
  for(var index, j = 0; j < letters.length; j++) {
    if((index = transFrom.indexOf(letters[j])) !== -1)
      letters[j] = transTo[index];
  }

  return letters
    .join("")
    .replace(/[^a-z0-9 ]+/g,'')
    .replace(/ +/g,'-');
}

function loadAndOpenModal(url, selector, size) {
  size = size || "lg";
  size = size.slice(0, 1).toUpperCase() + size.slice(1).toLowerCase();

  return ajaxGetSafe(url).then(function($page) {
    var $content = $page.find(selector);
    if(!$content.length)
      return;

    shoptet.modal.open({
      html: shoptet.content.colorboxHeader + $content.html() + shoptet.content.colorboxFooter,
      width: shoptet.modal.config["width" + size],
      className: shoptet.modal.config["class" + size],
      onComplete: function() {
        freeShippingLeft();
        $(".colorbox-html-content img").unveil();
        $("body").removeClass(shoptet.config.bodyClasses);
        if ($(".overlay").length > 0) {
            $(".overlay").detach()
        }
        setTimeout((function() {
            shoptet.modal.shoptetResize()
        }
        ), 1);
      }
    })
  });
}

function hookAjaxDone(url, callbackAfter) {
  var oldAjax = $.ajax;
  $.ajax = function(options) {
    var ajaxResult = oldAjax.apply($, arguments);
    if(options.url === url) {
      var oldDone = ajaxResult.done;
      ajaxResult.done = function() {
        return oldDone.apply(ajaxResult, [].slice.call(arguments).concat([ callbackAfter ]));
      };
    }
    return ajaxResult;
  };
}

// base object for all modules
var pendingModules = 0, afterModulesReady = [];
var Module = {
  snippets: {},

  init: function() {
    var self = this;
    ++pendingModules;
    loadSnippets(this.snippets).then(function(results) {
      self.snippets = results;
      if(self.snippetsLoaded)
        self.snippetsLoaded();
      self._bindShoptetEvents();

      if(!(--pendingModules)) {
        var tmpAfterModulesReady = afterModulesReady;
        afterModulesReady = [];
        for(let cb of tmpAfterModulesReady)
          cb();
      }
    });
    if(self.bindEvents)
      self.bindEvents();
    if(self.documentReady)
      $(document).ready(this.documentReady.bind(this, this.snippets));
  },
  _bindShoptetEvents: function() {
    for(var event of shoptet.scripts.availableDOMLoadEvents) {
      var method = event.replace(/^ShoptetDOM(.)/, function($0, $1) {
        return $1.toLowerCase();
      });

      if(this[method]) {
        $(document).on(event, this[method].bind(this, this.snippets));
        this[method](this.snippets);
      }
    }
  }
};
function waitForModules() {
  return new Promise(function(resolve) {
    if(!pendingModules)
      return resolve();
    afterModulesReady.push(resolve);
  });
}

// ======================== LAYOUT ========================

var Layout = Object.create(Module);
Layout.snippets = {
  emptySearch: "empty-search.html?v=4",
  emptyCartInner: "empty-cart-inner.html?v=5",
};
Layout.documentReady = function() {
  hookAjaxDone("/action/ProductSearch/ajaxSearch/", this.searchLoaded.bind(this));
  this.searchLoaded();
  this.initNavigation();
  this.initModalLinks();

  tb.hooks.hookFn("shoptet.cart.updateCartButton", function(updateCartButton, args, context) {
    var count = args[0], price = args[1];
    if(count > 0)
      $("#header .cart-count").addClass("full");

    updateCartButton.apply(context, args);
  });
};
Layout.cartContentLoaded = function() {
  this.initCartWidget();
};
Layout.searchLoaded = function() {
  this.initSearchWhisperer();
};
Layout.contentLoaded = function() {
  this.wrapBanners();
};
Layout.initCartWidget = function() {
  var $cart = $(".cart-widget"),
    $cartCount = $("#header .cart-count");

  if(!$cartCount.is(".full")) {
    $cartCount.find(".cart-price").html("Košík je prázdný");
    $cartCount.addClass("ready");

    var $inner = $cart.find(".cart-widget-inner");
    if(!$inner.find(".empty-cart-inner").length)
      $inner.prepend(Layout.snippets.emptyCartInner);

    if($("body").is(".cart-window-visible"))
      $("body").addClass("cart-window-visible-empty"); // handle click on last X

    $cart.find(".cart-widget-products").remove(); // remove Váš košík je prázdný.
  } else {
    $("body").removeClass("cart-window-visible-empty");
    $cart.find(".cart-widget-inner .empty-cart-inner").remove();
  }

  if(oneTime($cart)) // could be moved outside of initCartWidget, but here for cohesion
    $("body").on("mouseover", ".cart-count", handleCartCountHover);

  function handleCartCountHover() {
    var $cartCount = $(this),
      $cart = $(".cart-widget");

    if(!$cartCount.is(".full")) {
      $("body").addClass("cart-window-visible cart-window-visible-empty");
      $cart.find(".loader-overlay").hide();
    }
  }

  if($("body.mobile").length) {
    $("#header .cart-count:not(.full) i").remove();
    $("#header .cart-count:not(.full)").append("<i class='empty-i'>0</i>");
  }

  // move price
  $(".cart-widget-product", $cart).each(function() {
    var priceHtml = $(this).find(".cart-widget-product-name > span").remove().html();
    $(this).find(".cart-widget-product-name").after($('<div class="cart-widget-product-price"/>').html(priceHtml));
  });

  // move free shipping notice
  var $notice = $cart.find(".cart-widget-inner .cart-free-shipping"),
    $btnContainer = $cart.find(".cart-widget-button");
  if($notice.length) {
    $btnContainer.find(".cart-free-shipping").remove();
    $btnContainer.prepend($notice);
  }
  $(".cart-widget-button .btn-conversion").html("Pokračovat do košíku");

};
Layout.initSearchWhisperer = function() {

  var $whisperer = $(".search-whisperer.active");
  if(!$whisperer.length)
    return;
  var $links = $whisperer.find("> .search-whisperer-documents:first-child"),
    groups = { category: [], brand: [], article: [] };
  $links.children().each(function() {
    var $a = $(this);

    if($a.is(".search-whisperer-category"))
      groups.category.push($a);
    else if($a.find("em:contains(Značka)").length)
      groups.brand.push($a);
    else
      groups.article.push($a);
  });

  if(groups.category.length) {
    $links.append($('<div class="search-whisperer-col-categories"/>')
      .append('<h3>Nalezeno v kategoriích:</h3>')
      .append(groups.category));
  }
  if(groups.brand.length) {
    for(let $brand of groups.brand) {
      $brand.addClass("search-whisperer-brand");
    }

    $links.append($('<div class="search-whisperer-col-brands"/>')
      .append('<h3>Nalezeno ve značkách:</h3>')
      .append(groups.brand));
  }
  if(groups.article.length) {
    $links.append($('<div class="search-whisperer-col-articles"/>')
      .append('<h3>Nalezeno v článcích:</h3>')
      .append(groups.article));
  }

  $(".search-whisperer-empty").empty();
  $(this.snippets.emptySearch).prependTo(".search-whisperer-empty");


  /*$(".search-whisperer-documents.text-center").appendTo(".search-whisperer ul");*/

  $whisperer.find(".p-availability:contains('Skladem')").addClass("in-stock");
};

Layout.initTransit = function() {
  var $inner = $(".transit .inserthere");
  var $inner2 = $(".del-info span");
  if(!$inner.length)
    return;
  $.get("/doprava-a-platba/").done(function(data) {
    var page = document.implementation.createHTMLDocument("transitBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find("#shippingTable"),
      $wrapper2 = $page.find("h5")
    $inner.append($wrapper);
    $inner2.append($wrapper2);

  });
};

Layout.workHours = function() {
  const isPhoneStaffed = Fyft.isPhoneStaffed();
  if(isPhoneStaffed != null)
    $(".business-card, .project-phone, .contact-top>div:nth-of-type(1) a:nth-of-type(2)")
      .toggleClass("on", Boolean(isPhoneStaffed))
      .toggleClass("off", !isPhoneStaffed);
}

function lazyLoadImages($el) {
  $el = $($el);
  if($el.is("img")) {
    if(!$el.attr("data-src")) {
      $el.attr("data-src", $el.attr("src"));
      $el.attr("src", "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");
    }
  } else {
    $el.find("img").each(function() {
      lazyLoadImages(this);
    });
  }
}

function afterBlogBlockLoaded($inner) {
  $inner.find("img").unveil();
  $(".blog-block #newsWrapper .news-item").each(function() {
    $(this).find("a.title").clone().appendTo($(this).find(".description p:first-child")).html("více").addClass("arrow");
  });
}

Layout.initBlogBlock = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/eventy/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });
  $("<h2 class='title'><a href='/eventy/'>EVENTY</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/eventy/' title='Zobrazit všechny eventy' class='btn'>Zobrazit všechny eventy</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockSpeedcube = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/speedcube-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/speedcube-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/speedcube-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockKendama = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/kendama-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/kendama-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/kendama-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockDiscgolf = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/discgolf-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/discgolf-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/discgolf-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockYoyo = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/yoyo-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/yoyo-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/yoyo-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockHry = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/hry-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/hry-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/hry-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockMtg = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/mtg-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/mtg-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/mtg-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockCardistry = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/cardistry-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/cardistry-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/cardistry-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockJuggle = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/juggle-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/juggle-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/juggle-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initBlogBlockDrone = function() {
  var $inner = $(".blog-block .inner");
  if(!$inner.length)
    return;
  $.get("/cache/drone-racing-clanky/").done(function(data) {
    var page = document.implementation.createHTMLDocument("blogBlock");
    var $page = $(data, page), // load html without executing js
      $wrapper = $page.find(".news-wrapper");
    $wrapper.children().slice(3).remove();
    lazyLoadImages($wrapper);
    $inner.append($wrapper);
    afterBlogBlockLoaded($inner);
  });

  $("<h2 class='title'><a href='/drone-racing-clanky/'>Články</a></h2>").insertBefore(".blog-block .inner");
  $("<a href='/drone-racing-clanky/' title='Zobrazit další články' class='btn'>Zobrazit další články</a>").appendTo(".blog-block .center");
};

Layout.initRefBlock = function() {
  var $inner = $(".heureka-block"),
    $rate = $(".heureka-block .info-block .number"),
    $stars = $(".heureka-block .stars-block .stars"),
    $starslabel = $(".heureka-block .stars-block a span");

  if(!$inner.length)
    return;

  ajaxGetSafe("/cache/hodnoceni-obchodu/").then(function($page) {
    var $block = $page.find(".content-inner #ratingWrapper"),
      $ratein = $page.find(".content-inner #ratingWrapper .rate-average"),
      $starslabelin = $page.find(".content-inner .stars-label"),
      $starsin = $page.find(".content-inner .rate-average-inner .stars"),
      $wrapper = $page.find(".content-inner .votes-wrap");

    $wrapper.children().slice(2).remove();
    $stars.append($starsin);
    $starslabel.prepend($starslabelin);
    $rate.append($ratein);
    $inner.append($wrapper);

    // from here working with current page

    var $average = $(".heureka-block .rate-average");
    if($average.length) {
      var averageNum = parseFloat($average.text().trim().replace(/,/, "."));
      $average.text(Math.round(averageNum / 5 * 100));
    }

    $(".heureka-block .vote-wrap").each(function(index, element) {
      $(this).find(".vote-content").appendTo($(this).find(".vote-summary"));

      /*var percentage = Math.round(($(this).find(".stars").first().find(".star-on").length / 5) * 100);
      $("<div class='percentage'>"+ percentage +"%</div>").prependTo($(this).find(".stars-row"));*/
    });
  });
};

Layout.initNavigation = function() {
  var $navigation = $("#navigation");
  $navigation.find(".appended-category").remove();

  $("#navigation ul li a.active").parent().addClass("active");
  if($(window).width() >= 767)
    $("#navigation ul li a.active").closest("#navigation").addClass("active");
  $(".menu-helper").html("☰").appendTo(".navigation-in").addClass("ready");
  $("#navigation").addClass("ready");

  function normalizeUrl(url) {
    return (new URL(url, location.href)).pathname;
  }

  const activeUrls = new Set;
  activeUrls.add(normalizeUrl(location.pathname));
  $(".breadcrumbs a:not(.navigation-home-icon)").each(function() {
    var href = $(this).attr("href");
    activeUrls.add(normalizeUrl(href));
  });
  $("#navigation a").filter(function() {
    return activeUrls.has(normalizeUrl($(this).attr("href")));
  }).parent("li").addBack().addClass("active");


  var currentUrl = window.location.pathname;

    $(".navigation-in>ul>li>a").each(function() {
      var linkUrl = $(this).attr("href");

      if (linkUrl === currentUrl) {
        $(this).parent().addClass("active");
      }
    });


  $(".top-navigation-bar-menu").clone().addClass("responsive-menu-footer").appendTo(".navigation-in");
  $("#navigation").on("click", function(e) {
    var $t = $(this);
    setTimeout(function() {
      $t.toggleClass("has-exp", !!$t.find(".exp").length);
    }, 20);
  });

  function updateStickyNavbar() {
    var scrollTop = $(window).scrollTop();
    $(".top-navigation-bar, #header").toggleClass("sticky", !$("body").hasClass("search-window-visible") && scrollTop > 0);
  }
  $(window).on("scroll", updateStickyNavbar);
  updateStickyNavbar();

  function shuffleItems() {
    var $items = $navigation.find(".menu-level-1 > li"),
      $firstRow = $navigation.find(".navigation-in").first();

    var $measureUl = $('<ul class="menu-level-1 measure"/>')
      .append($items.clone());
    $measureUl.appendTo($firstRow);
    $measureUl.children().each(function(index) {
      $items.eq(index).attr("data-width", $(this).outerWidth(false));
    });
    $measureUl.remove();

    var maxWidth = $firstRow.width(),
      offset = 0;
    $items.each(function() {
      var width = parseFloat($(this).attr("data-width")); //outerWidth(false);

      if($(window).width() >= 767 && Math.floor(offset + width) - 5 > Math.ceil(maxWidth)) {
        var $nextRow = $navigation.find(".navigation-in.next");
        if(!$nextRow.length)
          $nextRow = $('<div class="navigation-in next menu"></div>').insertAfter($firstRow);
        if(!$nextRow.children("ul").length)
          $nextRow.append('<ul class="menu-level-1 next"/>');

        $nextRow.children(".menu-level-1").append(this);
      } else {
        $firstRow.children(".menu-level-1").append(this)
      }

      offset += width;
    });

    var $nextRow = $navigation.find(".navigation-in.next");
    if(!$nextRow.find(".menu-level-1").children().length) {
      $nextRow.children().remove(); // remove empty .menu-level-1
      $firstRow.removeClass("has-more");
    } else {
      $firstRow.addClass("has-more");
    }
  }

  shuffleItems();
  $(window).resize(debounce(shuffleItems, 500));

  if(document.fonts && document.fonts.ready)
    document.fonts.ready.then(shuffleItems);

  setTimeout(shuffleItems, 1000);
  setTimeout(shuffleItems, 5000);

  var $helper = $(".menu-helper");
  $helper.on("click", function(e) {
    e.preventDefault();

    if($navigation.is(".expanded")) {
      $(this).removeClass("expanded");
      $navigation.css("height", "").removeClass("expanded");
    } else {
      $(this).addClass("expanded");
      $navigation.css("height", $navigation.prop("scrollHeight")).addClass("expanded");
    }
  });
  $helper.on("mouseenter mouseleave", function(e) {
    e.stopPropagation(); // we don't have hover menu helper, so disable shoptet event handlers
  })
}

Layout.wrapBanners = function() {
  $(".extended-banner-title, .extended-banner-text, .extended-banner-link").each(function() {
	var $banner = $(this).parent();

	if(!$banner.is(".wrapper") && oneTime($banner, "wrapBanners"))
		$banner.children(".extended-banner-title, .extended-banner-text, .extended-banner-link").wrapAll("<div class='wrapper' />");
  });
};

Layout.initModalLinks = function() {
  $("body").on("click", "a.ajax-modal", function(e) {
    e.preventDefault();

    var selector = $(this).attr("data-selector") || "#content",
      size = $(this).attr("data-size");
    loadAndOpenModal($(this).attr("href"), selector, size);
  });
};

// ======================== HOMEPAGE ========================

var Homepage = Object.create(Module);
Homepage.documentReady = function() {
  this.initCarouselIndicators();
};
Homepage.initCarouselIndicators = function() {
  var $carousel = $("#carousel");
  if(!$carousel.length)
    return;

  var $indicators = $('<ol class="carousel-indicators"/>');
  $carousel.find(".carousel-inner .item").each(function(i) {
    $indicators.append($('<li>')
      .attr("data-target", "#" + $carousel.attr("id"))
      .attr("data-slide-to", i)
      .toggleClass("active", i === 0));
  });

  $carousel.prepend($indicators);
};


// ======================== CART ========================

var Cart = Object.create(Module);
Cart.snippets = {
  emptyCart: "empty-cart.html?v=3",
  quickPick: "quick-pick.html?v=4",
  cartHelp: "cart-help.html?v=4",
};
Cart.documentReady = function() {
  $("body.in-krok-1 .top-navigation-contacts").prependTo(".header-top .search");
  $("body.in-krok-2 .top-navigation-contacts").prependTo(".header-top .search");
  $("body.in-krok-1 .top-navigation-tools").prependTo(".navigation-buttons");
  $("body.in-krok-2 .top-navigation-tools").prependTo(".navigation-buttons");

  $(".cart-inner .cart-header").insertBefore("#content-wrapper").wrapAll("<div class='cart-header-wrap' />");
};
Cart.cartContentLoaded = function(snippets) {
  $(snippets.cartHelp).prependTo(".cart-inner .col-md-4");

  $(".cart-inner .delivery-time").insertAfter(".extra.delivery");

  $(".cart-inner .discount-coupon label").hide();
  $(".cart-inner .applied-coupon").insertBefore(".cart-summary");
  $(".cart-inner .applied-coupon strong").clone().addClass("coupon-item").insertBefore(".summary-wrapper .next-step");

  if($(".cart-inner .applied-coupon").length) {
    $("#coupontoggler").prop( "checked", true );
  }

  $("body.in-krok-1 .recapitulation-single strong:contains('Slevový kupon č.'), body.in-krok-2 .recapitulation-single strong:contains('Slevový kupon č.')").each(function() {
    var spanHtml = $(this).find('span').prop('outerHTML');
    var couponText = $(this).contents().filter(function() {
      return this.nodeType === 3 && this.textContent.trim().length > 0;
    }).text().split("-")[0].trim();
    $(this).html(spanHtml + couponText);
  });

  if($("body.in-kosik").length) {
   $("<div class='empty-cart-banners'></div>").insertAfter(".cart-inner.cart-empty");
   $("body.in-kosik .empty-cart-banners").load("/ .hp-categories", function() {
     $("<h2 class='h2-empty-cart'>Můžeš to však změnit. Například s něčím ze sekce:</h2>").prependTo(".empty-cart-banners");
   });
 }
 setTimeout(function(){
   $(snippets.quickPick).insertAfter(".empty-cart-banners");
 }, 50);

  $(".cart-inner.cart-empty h1.cart-heading").text("V tuto chvíli v košíku nic nemáš").addClass("ready");
  $(".cart-inner.cart-empty .empty-cart-boxes h3").html("Můžeš to však změnit.<br />Například s něčím ze sekce: ").addClass("ready");
  $(".cart-inner.cart-empty .col-md-4 .cart-content h4").text("Tvoje e-mailová adresa").addClass("ready");

  $("body.in-kosik .cart-table").find(".p-discount").closest("table").addClass("with-disc");
  $("<tr class='top'><td colspan='2'>Produkt:</td><td>Dostupnost:</td><td>Množství:</td><td>Cena/ks</td><td>Celkem</td></tr>").prependTo("body.in-kosik .cart-table:not(.with-disc) tbody");
  $("<tr class='top'><td colspan='2'>Produkt:</td><td>Dostupnost:</td><td>Množství:</td><td>Cena/ks</td><td>Sleva:</td><td>Celkem</td></tr>").prependTo("body.in-kosik .cart-table.with-disc tbody");
  $(".next-step-forward").html("Pokračovat v objednávce");
  $('<div class="form-group"><input type="checkbox" name="coupontoggler" id="coupontoggler" value="1"><label for="coupontoggler" class="whole-width">Mám slevový kód</label></div>').prependTo(".discount-coupon");
  $("#coupontoggler").click(function() {
    $(".discount-coupon form").toggleClass("active");
  });
  $("<span>1. </span>").prependTo("h4.order-delivery");
  $("<span>2. </span>").prependTo("h4.order-payment");

  $(".cart-content .radio-wrapper .payment-info .question-tooltip").each(function() {
    var $speclink = $(this),
    spec = $speclink.attr("data-original-title") || $speclink.attr("title");
    $(this).parent().html(spec);
  });

  $("#checkoutSidebar .cart-content h4").html("Shrnutí objednávky");
  $("<div class='back-shopping-link'><a href='' class='next-step-back' title='Předchozí krok'>Předchozí krok</a></div>").appendTo("#checkoutSidebar")
  $("#checkoutSidebar .back-shopping-link").click(function(event) {
    event.preventDefault();
    history.back(1);
  });

  $("#checkoutSidebar .cart-items .cart-item").each(function() {
    $(this).find(".cart-item-amount, .cart-item-price").wrapAll("<div class='cart-item-price-amount' />");
  });

  $("#checkoutContent .stay-in-touch .form-group:last-of-type").appendTo("#checkoutContent .co-contact-information");

  $("#checkoutContent .co-contact-information").find(".form-group label[for=login]").parent().addClass("login-form-group");
  $(".login-form-group").clone().prependTo("#checkoutContent");
  $(".login-form-group label").html("Máš u nás účet? Přihlaš se a všechny údaje vyplníme.").removeClass("btn btn-secondary");
  $(".login-form-group a").html("Přihlásit se").removeClass("btn btn-secondary");
  $(".in-dekujeme .content-inner .recapitulation-wrapper:first-of-type .co-payment-method table tr:last-child th").html("Celkem k úhradě: ");

  /*$("<span>Připsat poznámku k objednávce</span>").appendTo("body.in-krok-2 .form-group label.whole-width[for=add-note]");*/
  $("body.in-krok-2 .form-group label.whole-width[for=add-note]").text("Připsat poznámku k objednávce");

  $("<p class='reca-p'>Děkujeme ti za objednávku! Máme radost, že ses rozhodl/a investovat do svého volného času offline!</p>").insertAfter("body.in-dekujeme .reca-number");

  $("<p>Nedaří se ti zaplatit kartou? Nevadí! Objednávku máme uloženou a nepodaří-li se ti to, na e-mail ti za chvíli přijdou informace k bankovnímu převodu. Pokud bys chtěl/a poslat na dobírku, stačí nám napsat.</p>").insertAfter("body.in-dekujeme .suspend-redirect+.spaced-small");

  var $box = $(".co-box.co-payment-method");
  if($box.find(".recapitulation-table").length === 1) {
   $box.find(".recapitulation-table").eq(0).addClass("totals-table");
  } else if($box.find(".recapitulation-table").length === 2) {
    $box.find(".recapitulation-table").eq(0).addClass("totals-table");
    $box.find(".recapitulation-table").eq(1).addClass("payment-table");
  }

  $("<h5>Informace pro platbu převodem</h5>").insertBefore(".in-dekujeme .content-inner .co-payment-method .payment-table");

  /*$("#checkoutContent input").each(function(index, elem) {
     var eId = $(elem).attr("id");
     var label = null;
     if (eId && (label = $(elem).parents("form").find("label[for="+eId+"] span")).length == 1) {
         $(elem).attr("placeholder", $(label).html());
     }
  });*/

  $("body.in-krok-2 label[for=email]>span").text("E-mail");

  $("#checkoutContent .co-box.co-contact-information .form-group:last-of-type()").insertAfter("#checkoutContent #note");



  $(snippets.emptyCart).appendTo(".cart-inner.cart-empty .col-md-8");

  if($("body.in-krok-2").length)
    this.storeOrderInfo();

  if($("body.in-dekujeme").length)
    this.displayOrderInfo();
};
Cart.initTipProductBasket = function(snippets) {
  $(snippets.tipProductBasket).prependTo(".cart-inner .cart-summary");
  var $tip = $(".tip-product-basket");
  if(!$tip.length)
    return;

  if(!Cart.$tipProductPrice) {
    var productUrl = $tip.find("a").attr("href");
    ajaxGetSafe(productUrl).then(function($page) {
      Cart.$tipProductPrice = $page.find(".p-final-price-wrapper");
      Cart.injectTipProductPrice();
    });
  } else {
    Cart.injectTipProductPrice();
  }

  $tip.find("input[type=checkbox]").on("change", function(e) {
    var $t = $(this),
      $tip = $t.closest(".tip-product-basket");
    if($t.is(":checked")) {
      shoptet.cartShared.addToCart({ priceId: $tip.data("priceId") });
    } else {
      $(".cart-content .p-total form").each(function() {
        var priceId = $(this).find("input[name=priceId]").val();
        if(priceId == $tip.data("priceId"))
          $(this).find(".remove-item").click();
      });
    }
  });

  var productsInCart = $(".cart-content .p-total input[name=priceId]").map(function() { return parseInt($(this).val(), 10); }).toArray();
  $tip.each(function() {
    var priceId = parseInt($(this).data("priceId"), 10);
    if(productsInCart.indexOf(priceId) !== -1)
      $(this).find("input[type=checkbox]").prop("checked", true);
      // $(this).fadeOut(shoptet.config.animationDuration);
  });
};
Cart.injectTipProductPrice = function() {
  if(!Cart.$tipProductPrice || !Cart.$tipProductPrice.length)
    return;

  var $price = $(".tip-product-basket .p-price");
  $price.toggleClass("discounted", !!Cart.$tipProductPrice.find(".price-save").length);
  $price.html(Cart.$tipProductPrice.html());
};
Cart.storeOrderInfo = function() {
  if(!window.sessionStorage)
    return;

  sessionStorage.setItem("orderSummary", $(".order-summary-inner").html());
};
Cart.displayOrderInfo = function() {
  if(!window.sessionStorage)
    return;
  var html = sessionStorage.getItem("orderSummary");
  if(!html)
    return;
  var $summary = $(html),
    $table = $(".recapitulation-table");

  // if sessionStorage contains invalid data, don't show deceiving information
  $summary.find(".recapitulation-single").each(function() {
    var $t = $(this),
      label = $t.find("> span").text().trim(),
      price = $t.find("> strong > span").html(),
      value = $t.find("> strong").children().remove().end().html();

    var $tr;
    switch(label) {
      case "Způsob dopravy":
        $tr = $table.find("th:contains(doprava)").parent();
        break;
      case "Platba":
        $tr = $table.find("th:contains(platba)").parent();
        break;
    }
    if(!$tr || !$tr.length)
      return;

    $tr.find("th").html($tr.find("th").html().trim() + ": " + $tr.find("td").html());
    $tr.find("td").html(price);
  });
};

// ======================== CATALOG ========================

function filterAvailabilityAmount(amount) {
  amount = amount.trim().replace(/[\(\)]/g, "");
  if(amount !== "" && amount.indexOf("ks") === -1)
    amount += " ks";
  return amount;
}

var Catalog = Object.create(Module);
Catalog.snippets = {

};
Catalog.documentReady = function() {
  this.hideAdvancedOrderMessage();
};
Catalog.contentLoaded = function(snippets) {
  this.initProductBlocks(snippets);
  this.initTopBanner();
  this.initFilters(snippets);
  this.initAdvancedOrder(snippets);
  this.initSortLinks();
};
Catalog.initProductBlocks = function(snippets) {
  $(".products-block .product").each(function() {
    if(oneTime(this))
      Catalog.initProductBlock($(this), snippets);
  });

  $(".products-top .product").each(function() {
    if(oneTime(this))
      Catalog.initProductTop($(this), snippets);
  });

};
Catalog.initProductTop = function($t, snippets) {
    $t.find(".availability:contains('Skladem')").parents().eq(4).addClass("p-in-stock").prependTo("#productsTop");
}
Catalog.initProductBlock = function($t, snippets) {
  $(".availability:contains('Skladem')").addClass("in-stock");
  const $flagDiscount = $t.find(".flag.flag-discount");
  if($flagDiscount.length) {
    const $priceStandard = $flagDiscount.find(".price-standard");
    const priceFrom = $priceStandard[0]?.previousSibling;
    if(priceFrom?.nodeType === Node.TEXT_NODE)
      priceFrom.remove();
    $priceStandard.insertBefore($t.find(".price.price-final")).parent().addClass("discount");
  }

  $t.find(".category-appendix").wrapAll("<div class='appendix-wrap'></div>");
  $t.find(".appendix-wrap").insertAfter($t.find(".name span[data-micro=name]"));

  $("body.mobile .advanced-order #products").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true
  });
  $("body.mobile .advanced-order #products").slick('refresh');
};
Catalog.initAdvancedOrder = function(snippets) {
  var $modal = $(".advanced-order");
  if(!$modal.length || !oneTime($modal))
    return;

  $(".advanced-order .extras-wrap").append(tb.$h(".extra.step", $(".advancedOrder__buttons").detach().find(".btn-conversion")));
  $("<div onclick='shoptet.modal.close();' class='extra backto'>Pokračovat v nákupu</div>").prependTo(".advanced-order .extras-wrap");
  $(".advanced-order .extras-wrap .extra.step .btn").html("PŘEJÍT DO KOŠÍKU");
  $(".advanced-order > .h1:not(.advanced-order-suggestion)").html("Úspěšně jste přidali do košíku");
  $(".advanced-order > .h1:not(.advanced-order-suggestion), .advanced-order > .h2").wrapAll("<div class='adv-wrap'></div>");
  $modal.closest("#cboxContent").addClass("cbox-transparent").css("background", "transparent");

  $(document).one("cbox_closed", function() {
    $("#cboxContent").removeClass("cbox-transparent").css("background", "");
  });


};
Catalog.hideAdvancedOrderMessage = function() {
  var lastGetAdvancedOrder = 0;
  hooks.hookBeforeShoptetFn("shoptet.cart.getAdvancedOrder", function() {
    lastGetAdvancedOrder = Date.now();
  });

  hooks.hookFn("window.showMessage", function(showMessage, args, context) {
    if(args[1] === "success" && Date.now() - lastGetAdvancedOrder <= 500)
      return;
    showMessage.apply(context, args);
  });
};
Catalog.initTopBanner = function() {
  if(!$(".type-category").length) // not category view
    return;

  if(!$(".c-category-top").length) { // not initialized
    $(".category-title").prependTo("body.type-category #content-wrapper").wrapAll("<div class='c-category-top'></div>");
    $(".category-perex:not(.empty-content)").appendTo(".c-category-top");
    $(".c-category-top .category-perex:not(.empty-content)").wrapInner("<div class='category-perex__wrap'></div>");
    $(".detail-sidebar-help").insertAfter(".category-perex__wrap");
    $(".category-perex").find("video").closest(".c-category-top").addClass("video-added");
    $(".video-added.c-category-top h1").insertAfter(".category-perex video");
    $(".category-perex").find("video, h1").wrapAll("<div class='wrapped-h1'></div>");
    $(".wrapped-h1").insertBefore(".category-perex__wrap");
    if ($(".c-category-top h1").text().length > 17)
      $(".c-category-top h1").addClass("more-letters");

    $(".c-category-top .category-perex .bottom-text").insertAfter(".pagination-wrapper");

    var $subcategoriesImport = $(".subcategories-import").first();
    if($("#content .category-top> .subcategories").length)
      $("#content .category-top > .subcategories").append($subcategoriesImport.children());
    else
      $(".c-category-top").after($subcategoriesImport.clone().removeClass("subcategories-import"));

    $(".subcategories").appendTo(".c-category-top");
  }

  $(".category-top>h4, .category-top>#productsTop").prependTo(".category-content-wrapper");

  var hidePerex = false;
  if($(".pagination").length && !$(".pagination .current:first-child").length)
    hidePerex = true;
  if($("#manufacturer-filter input:checked").length)
    hidePerex = true;

  if(hidePerex) {
    $(".bottom-text").remove();

    if($(".c-category-top.video-added").length) {
      $(".c-category-top video").closest("p").nextAll().remove();
    } else {
      $(".category-perex").remove();
    }
  }

  $("body.type-category .sidebar-inner").addClass("ready");

};

Catalog.hiddenFilters = {};
Catalog.initFilters = function() {
  $("#filters .filters__msg-box").remove();
  try {
    filtersArticles();
  } catch(err) {
    console.error(err);
  }

  if(oneTime($("body"))) {
    // bind events
    $("body").on("click", ".filter-section", function(e) {
      var $t = $(this),
        $target = $(e.target);

      var filterIndex = $t.index();

      if(!$t.is(".active")) {
        $t.addClass("active");
        $t.find("form").slideDown();
        Catalog.hiddenFilters[filterIndex] = false;
      } else if($target.closest("h4").length) {
        $t.removeClass("active");
        $t.find("form").slideUp();
        Catalog.hiddenFilters[filterIndex] = true;
      }
    });
  }

  // restore active filters after ajax
  $(".filter-section").each(function() {
    var $t = $(this);
    //$t.addClass("active");

    if(!Catalog.hiddenFilters[$t.index()]) {
      $t.addClass("active");
      $t.find("form").show();
    }
  });

  // add sort by newest
  var $sortFieldset = $("#category-header > form fieldset");
  if(tb.dom.oneTime($sortFieldset, "sortByNewest")) {
    var $radio = $('<input type="radio" value="-date" name="order" id="order6" data-url="?order=-date">'),
        $label = $('<label for="order6">Nejnovější</label>');
    if(location.search.indexOf("order=-date") !== -1)
      $radio.prop("checked", true);
    $sortFieldset.append($radio, $label);
  }

  // add mobile select for sorting
  var $fieldset = $("#category-header > form fieldset");
  if(oneTime($fieldset, "initFilters")) {
    var $select = $('<select class="mobile-sort"/>');
    $fieldset.find("input[type=radio]").each(function() {
      var $t = $(this);
      $select.append(
        $("<option/>").prop("value", $t.prop("value"))
          .prop("selected", $t.is(":checked"))
          .text($t.next("label").text().trim()));
    });
    $select.on("change", function(e) {
      e.preventDefault();
      var value = $(this).val();
      $fieldset.find("input[type=radio][value=\"" + value + "\"]").prop("checked", true).trigger("click");
    });
    $fieldset.after($select);
  }

  if($(window).width() < 1024) {
    if(!$("#filters .top-h3").length) {
      $("<h3 class='top-h3'>Filtrovat produkty</h3>").prependTo("#filters");
      $(".top-h3").click(function(){
        $(".slider-wrapper, .filter-sections").toggle();
        $("#filters").toggleClass("visible-init");
      });
    }

    $(".mobile-sort option[value='name']").remove();
  }
};
Catalog.initCategoryTopBottom = function() {
  if(!$(".type-category").length || $(".c-category-top").length)
    return;

  if(!oneTime($("#products"), "initCategoryTopBottom")) // this is only partial refresh (Load More) - #content wasn't replaced
    return;

  if($(".c-category-top").length) {
    $(".c-category-top").find(".category-perex, h1, .read-more-wrap").remove();
  } else {
    $(".breadcrumbs-wrapper").wrapAll("<div class='c-category-top ready'><div class='container'></div></div>");
  }


  $(".type-category .subcategories:not(.ready)").insertAfter(".type-category .c-category-top").wrapAll("<div class='categories-top ready'><div class='container'></div></div>");
  $(".subcategories").addClass("ready");


  $("#content").find(".category-perex, h1").appendTo($(".c-category-top > .container"));

  $(".dkLabVisitedProducts").insertAfter("body.type-category");

  $(".c-category-top, .category-bottom").addClass("ready");
};

Catalog.initSortLinks = function() {
  $("body.type-category .categories.active").prependTo("body.type-category .box-categories").wrap("<div id='categories' class='ready'></div>");
  $("#categories:empty").remove();
  $(".param-filter-top").clone().insertBefore(".category-header:not(.added) div").closest(".category-header").addClass("added");
  if($("#clear-filters").length) {
  $("#filters").addClass("--clear-filters");
  }
  else {
    $("#filters").removeClass("--clear-filters");
  }

  $('.category-perex a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex','-1');
            $target.focus();
          };
        });
      }
    }
  });
};

// ======================== DETAIL ========================

var Detail = Object.create(Module);
Detail.documentReady = function() {
  const { $h, $t } = tb;
  const $infoWrapper = $(".p-detail .p-info-wrapper");

  $infoWrapper.find(".availability-amount").each(function() {
    $(this).text($(this).text().replace(/[\(\)]/g, ""));
  });

  $infoWrapper.find(".availability-value, .add-to-cart").wrapAll("<div class='p-detail-price-block' id='buyhere'/>");
  $infoWrapper.find(".add-to-cart .quantity, .add-to-cart-button").wrapAll("<div class='right-block' />");
  $(".p-detail .availability-value, .p-info-wrapper .add-to-cart, .p-info-wrapper .detail-parameters").addClass("ready");
  $(".p-final-price-wrapper .price-standard, .p-final-price-wrapper .price-save").wrapAll("<div class='detail-prices'></div>");
  $(".p-detail h1").prependTo(".p-info-wrapper");
  $("<div class='flags-here'></div>").insertAfter(".p-detail-inner h1");
  $(".p-detail .product-top .flags-default").appendTo(".flags-here");
  $(".p-detail-inner-header, .p-detail-info").insertAfter(".p-detail-inner h1");
  if($(window).width() < 1024) {
    $("body.mobile .p-detail h1").prependTo(".p-detail .p-image-wrapper");
    $(".p-detail h1").prependTo(".p-detail .p-image-wrapper");
  }



  $(".p-gifts-wrapper").insertAfter(".p-short-description.visible").addClass("ready");
  $(".extended-description > h3").html("Parametry");
  $(".extended-description table").wrapAll("<div class='param-table-desc'></div>");

  $(".p-detail #productVideos").removeClass("tab-pane fade").appendTo(".p-detail #tab-content #description .description-inner");
  Detail.unveilVideos();

  $(".p-detail #relatedFiles").removeClass("tab-pane fade").appendTo(".p-detail #tab-content #description .basic-description");

  $("#productVideos>h3, #productVideos>iframe").each(function(){
    $(this).nextUntil("h3").addBack().wrapAll("<div class='item' />");
  });

  $(".p-info-wrapper .variant-list select option[data-index='0']").html("Vyber si variantu");


  /*var $variants = $wrapper.find(".availability-value .choose-variant"),
    hasVariants = true;
  if(!$variants.length) {
    hasVariants = false;
    $variants = $wrapper.find(".availability-value");
  }

  $variants.each(function() {
    var $deliveryTime;
    if(hasVariants) {
      var m = $(this).attr("class").match(/([0-9][0-9-]*)/);
      if(!m)
        return;
      var className = m[1];
      $deliveryTime = $wrapper.find(".delivery-time ." + className);
    } else {
      $deliveryTime = $wrapper.find(".delivery-time span");
    }

    if($deliveryTime.length) {
      var html = $deliveryTime.html();
      // remove year if current
      html = html.replace(/([0-9]+)\.([0-9]+)\.([0-9]+)/, function($0, d, m, y) {
        var date = new Date(parseInt(y, 10), parseInt(m, 10) - 1, parseInt(d, 10));
        if(date.getFullYear() === (new Date).getFullYear())
          y = "";

        var weekday = [
        "v neděli", "v pondělí", "v úterý", "ve středu",
        "ve čtvrtek", "v pátek", "v sobotu"
        ][date.getDay()];

        return ", " + weekday + " " + d + "." + m + "." + y + " odesíláme";
      }).trim();
      $(this).append($('<span class="delivery-time-custom"/>').html(html));
    }

    trimHtml($(this).find(".availability-amount"));

    $(this).find(".availability-label, .availability-amount, .delivery-time-custom").wrapAll('<div class="block"/>');
    $(this).filter(":contains(Skladem)").addClass("in-stock");
  });*/
  $(".p-detail .availability-label:contains('Skladem')").addClass("in-stock");
  $(".p-detail .availability-value .availability-amount:contains('> 5')").html("").addClass("more");
  $(".p-detail .availability-value .availability-amount.more").html("(více než 5ks)");

  if(!$("body.type-detail .p-detail .availability-value .in-stock").length) {
    $("body.type-detail .products-block.products-alternative .ratings-wrapper .availability:not(.in-stock)").closest(".product").remove();
    $("body.type-detail .sim-products").insertAfter(".product-top");
  }

  $(".p-info-wrapper .detail-parameters").insertBefore(".p-info-wrapper .add-to-cart");

/*  $("<div id='watchdog-btn' class='' >Hlídat produkt</div>").insertAfter(".p-detail .p-detail-price-block");
  $("#watchdog-btn").click(function(){
    $(".link-icon.watchdog").click();
  });
  $("<div id='counseling' class='' >Dotaz k produktu</div>").insertAfter(".p-detail .p-detail-price-block");
  $("#counseling").click(function(){
    $(".link-icon.chat").click();
  });*/


  $(".p-detail .p-info-wrapper .dkLabFavDiv").appendTo(".p-detail .p-info-wrapper .flags-here");

  function toggleWatchdog(v) {
    $(".p-detail .p-info-wrapper").toggleClass("watchdog-visible", !!v);
  }
  tb.m.DetailHooks.hookAfterVariantChange(() => {
    toggleWatchdog(InStock.isWatchdogVisible($(".p-detail")));
  });
  $h(".watch-dog", Fyft.t.detailWatchdogBtn).on("click", e => {
    $(".link-icon.watchdog").click();
  }).insertBefore(".p-detail .social-buttons-wrapper");

  $("<a href='/doprava' id='delivery-options' class='ajax-modal' data-selector='.transit-block-over' data-size='md'>Možnosti doručení</a>").appendTo(".p-info-wrapper .availability-value");
  $(".watch-dog").wrapAll("<div class='watch-del-wrap'></div>");

  $("<p>Veškeré hodnocení jsou schvalovány. Sprosté a reklamní komentáře jsou mazány.</p>").insertBefore("#ratingWrapper .col-xs-12 .form-group:last-of-type()");

  $('<div class="categories-detail"><h3>Zařazeno v:</h3><div class="inner"></div>').appendTo("body.type-detail .param-table-desc");
  $(".breadcrumbs a:not(.navigation-home-icon)").each(function() {
    $(this).clone().appendTo(".categories-detail .inner");
  })

  var $manuf = $(".p-detail-info>div:contains(Značka)");
  if(tb.dom.oneTime($manuf))
    $(".p-info-wrapper .availability-value").after(tb.$h(".detail-manufacturer", [
      tb.$h("strong", "Výrobce: "),
      $manuf.find("a").clone()
    ]));

  this.initTabs();
  this.initAjaxTabs();

  $(document).trigger("detailReady");
};

Detail.unveilVideos = function() {
  $("[data-iframe-src]").each((function() {
      var self = $(this);
      self.attr("src", self.data("iframe-src"));
      self.removeAttr("data-iframe-src");
      self.on("load", (function() {
          self.prev(".loader").remove()
      }
      ))
    }
  ));
};

// delay shpResponsiveNavigation in detail
(function() {
  var oldShpResponsiveNavigation = $.fn.shpResponsiveNavigation;
  if(!oldShpResponsiveNavigation)
    return;

  $.fn.shpResponsiveNavigation = function(ignoreFilter) {
    var $filtered = ignoreFilter ? this : this.filter(function() {
      return !$(this).find("#p-detail-tabs").length;
    });

    return oldShpResponsiveNavigation.call($filtered);
  };
})();

Detail.initTabs = function() {
  if(!$("body.type-detail").length)
    return;

  var $headings = $(
    $("#description .basic-description h3").get()
    .concat($("#content .sim-products .h4").get())
    .concat($("#content .rel-products .h4").get()));
  var $nav = $(".p-detail-tabs");

  $nav.find('li.shp-tab:contains(Podobné)').hide();
  $nav.find('li.shp-tab:contains(Videa)').hide();
  $nav.find('li.shp-tab:contains(Diskuse)').hide();

  /*$nav.append(
    $('<li class="shp-tab">')
    .append($('<a class="shp-tab-link ajax-tab-link" href="#doprava-a-platba" data-href="/doprava-a-platba/" data-toggle="tab">Doprava</a>')));*/

};

Detail.initAjaxTabs = function() {
  if(!$("body.type-detail").length)
    return;

  function loadTab($t) {
    var target = $t.attr("href").slice(1);
    if($tabContent.find("#"+target).length)
      return;

    var $div = $('<div class="tab-pane fade"/>').attr("id", target);
    $tabContent.append($div);

    $.get($t.attr("data-href")).then(function(data) {
      var $payload = $(shoptet.common.createDocumentFromString(data));
      $div.html($payload.find("#content .content-inner").html());

      var $header = $div.find("article header");
      if($header.length) // replace h1 with h2
        $header.after($('<h2/>').html($header.find("h1").html())).remove();
    });
  }

  var $nav = $(".p-detail-tabs"),
    $tabContent = $("#tab-content");
  $nav.on("mouseover click", ".ajax-tab-link", function(e) {
    var $t = $(this);
    loadTab($t);
  });
};

// ======================== SEARCH ========================

var Search = Object.create(Module);
Search.hideTabs = function() {
  // called from below after snippets loaded

  $(".search-nav a").each(function() {
    var $t = $(this);

    var $target = $($t.attr("href"));
    if(!$target.length || !$target.children(":not(h4)").length) // nonexistent or just heading (Produkty nebyly nalezeny)
      $t.remove();
  });
};

// ======================== POST ========================

var Post = Object.create(Module);
Post.documentReady = function() {


};
Post.initRecipeMeta = function() {

};
Post.initTables = function() {

};

// ================================================

var RecentProducts = (function() {

  var init = tb.dom.createModuleInitializer({
    earlyInit: function() {
      if(!$("body.type-category, body.type-detail").length)
        return false;
    },
    render: function() {
      if(tb.dom.oneTimeContents("body.type-category #content-wrapper, body.type-product main#content", "RecentProducts")) {
        var $block = tb.m.RecentProductsLib.renderRecentlyViewedBlock();
        if(!$block.length) // no recent products
          return;

        $("body.type-category #content-wrapper, body.type-product main#content").append($block);
        tb.hooks.signalDomLoad();

        $block.find("img").unveil();
        Catalog.initProductBlocks();
        $(".products-recent").slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 2,
          dots: true,
          responsive: [
           {
             breakpoint: 1200,
             settings: {
               slidesToShow: 3,
               slidesToScroll: 2
             }
           },
           {
             breakpoint: 767,
             settings: {
               slidesToShow: 1,
               slidesToScroll: 1
             }
           }
         ]
        });

        if($("body.type-detail").length)
          tb.$h(".usps", [ $(".custom-footer>div:nth-of-type(5)").clone() ]).insertBefore($block);
      }
    }
  });

  return { init: init };
})();

// var RecentProducts = (function($h) {
//   function addDetailButton() {
//     var $p = $(this);
//     if(!tb.dom.oneTime($p, "addDetailButton"))
//       return;
//     $p.find(".prices").after($h(".p-tools", [
//       $h("a", { href: $p.find(".name").attr("href"), class: "btn btn-primary" }, "Detail")
//     ]));
//   }

//   var init = tb.dom.createModuleInitializer({
//     render: function() {
//       var $box = $(".dkLabVisitedProductsBox");

//       $box.find("h2").replaceWith($h(".h4", "Naposledy prohlížené"));
//       $box.find(".products").addClass("products-block container").removeClass("products-inline");

//       $box.find(".p").each(addDetailButton);

//       if($("body.type-category").length)
//         $box.insertAfter("#content-wrapper");
//       else if($("body.type-product").length)
//         $box.appendTo("main#content");

//       Catalog.initProductBlocks();
//         if($("body.type-detail .dkLabVisitedProductsBox").length)
//           $(".custom-footer>div:nth-of-type(5)").clone().insertBefore("body.type-detail .dkLabVisitedProductsBox").wrapAll("<div class='usps'></div>");
//     }
//   });

//   return { init: init };
// })(tb.$h);

var Watchdog = (function() {
  function checkOnStock() {
    var $form = $("#watchdog-form");
    $form.find("#onStock").prop("checked", true);
  }

  var init = tb.dom.createModuleInitializer({
    domReady: function() {
      $("body").on("change", "#watchdog-simple-variants-select", checkOnStock);
      tb.hooks.hookAfterAjaxDone(/\/watchdogInfo\//, function() {
        checkOnStock();
      });
    },
    render: function() {
      checkOnStock();
    }
  });

  return { init: init };
})();

var TrackTopProducts = (function() {
	var config = {
    promoId: "TOP_PRODUCTS",
    promoName: "Nejprodávanější",
    listName: "Nejprodávanější"
	};

	function trackTopProductClick(gaData, url) {
    try {
		  if (typeof gtag === "function") {
        gtag("event", "select_content", {
          content_type: "product",
          items: [{
            id: gaData.content_ids[0],
            name: gaData.base_name,
            // category: gaData.content_category,
            // brand: gaData.manufacturer,
            // variant: gaData.variant,
            price: gaData.valueWoVat,
            // quantity: amount,
            list_name: config.listName
          }]
        });
        gtag("event", "select_content", {
          send_to: "analytics",
          promotions: [{
            name: config.promoName,
            id: config.promoId,
          }],
          event_callback() {
            document.location = url;
          }
        });
        setTimeout(function() {
          document.location = url;
        }, 750);
        return true;
      }
    } catch(err) {
      console.error(err);
    }
	}

	function extractGaDataFromProductBlock($p) {
		return {
			content_ids: [ $p.data("microProductId") ],
			base_name: $p.find("[data-micro=name]").text().trim(),
			valueWoVat: tb.common.parseNumber($p.find("[data-micro=offer]").data("microPrice"))
		};
	}

	var init = tb.dom.createModuleInitializer({
		domReady: function() {
			$("body").on("click", "#productsTop a", function(e) {
				var url = $(this).attr("href"),
					gaData = extractGaDataFromProductBlock($(this).closest(".p"));
					console.log(gaData);
				if(trackTopProductClick(gaData, url))
					e.preventDefault();
			});
		}
	});

	return { init: init };
})();

const AdvancedOrderProductInfo = (function(AdvancedOrderHooks) {
  function extractProductInfo($form) {
      const info = {
        amount: parseInt($form.find("[name=amount]").val(), 10) || 1
      };
      return info;
    }
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      AdvancedOrderHooks.init();

      AdvancedOrderHooks.addContentFilter(function(content, $lastForm) {
        const productInfo = extractProductInfo($lastForm);
        const $wrap = tb.$h("div", [ content ]);

        var $modal = $wrap.find(".advanced-order");
        if($modal.length && productInfo)
          $modal.find(".h2").prepend(tb.$h("span.p-amount", productInfo.amount + "ks"));

        return $wrap.html();
      });
    }
  });

  return { init };
})(tb.m.AdvancedOrderHooks);


var DetailPerCategoryContent = (function() {
  function isCategory(url) {
    return !!$(".breadcrumbs a").filter(function() {
      return $(this).attr("href") === url;
    }).length;
  }

  var init = tb.dom.createModuleInitializer({
    earlyInit() {
      if(!$("body.type-detail").length) {
        $(".js-append-to-detail-sidebar").remove();

        return false;
      }
    },
    domReady() {
      $(".js-append-to-detail-sidebar").each(function() {
        var $t = $(this);
        if($t.data("categories") && !$t.data("categories").split(",").some(isCategory))
          return;
        if(!$("body.type-detail .extended-description").length) {
          $("<div class='extended-description'></div>").insertAfter(".basic-description");
        }
        $t.contents().appendTo("#description .extended-description");
      }).remove();
    }
  });

  return { init };
})();

var LeftToFreeShippingFix = (function() {
  function updateDataLayer(content) {
    var $wrap = tb.$h("div", [ content ]),
      $delivery = $wrap.find(".extra.delivery > span");

    var cartInfo = getShoptetDataLayer().cartInfo;
    if($delivery.text().includes("Dopravu máte zdarma!"))
      cartInfo.freeShipping = true;
    else if($delivery.text().includes("Objednejte ještě za")) {
      var priceLeft = tb.common.parseNumber($delivery.children("strong").first().text());

      cartInfo.freeShipping = false;
      cartInfo.leftToFreeShipping.priceLeft = priceLeft;
      cartInfo.leftToFreeShipping.formattedPrice = priceLeft.ShoptetFormatAsCurrency();
    }
  }

  function init() {
    m.AdvancedOrderHooks.addContentFilter(function(content) {
      updateDataLayer(content);
      return content;
    });
  }

  return { init };
})();

var AdvancedOrderMoreRelated = (function() {
  var config = {
    sourceUrl: "/doplnujici-produkty/",
    minProducts: 4
  };

  function isInStock($p) {
    return !!$($p).find(".availability:contains(Skladem)").length;
  }

  function fetchMoreProducts(count) {
    return tb.ajax.loadDocument(config.sourceUrl).then(function($payload) {
      var $products = $payload.find("#products").children();

      var productsInStock = $products.filter(function() {
        return isInStock(this);
      }).toArray(),
        productsOutOfStock = $products.filter(function() {
          return !isInStock(this);
        }).toArray();

      var res = [];
      for(let i = 0; i < count; i++) {
        let list = productsInStock.length ? productsInStock : productsOutOfStock;
        if(!list.length)
          break;
        let rand = Math.floor(Math.random()*list.length);
        res.push(list.splice(rand, 1)[0]);
      }

      return res;
    });
  }

  function init() {
    m.AdvancedOrderHooks.addContentFilter(function(content) {
      var $wrap = tb.$h("div", [ content ]);

      var $products = $wrap.find(".products-related");
      var missingCount = config.minProducts - $products.children().length;
      console.log("loading", missingCount, "additional products");

      if(missingCount <= 0)
        return content;

      return fetchMoreProducts(missingCount).then(function(additionalProducts) {
        if(!$products.length) {
          var $extrasWrap = $wrap.find(".extras-wrap");
          $products = tb.$h("#products.products.products-block.products-additional.products-related.p-switchable").insertAfter($extrasWrap);
          tb.$h("div.h1.advanced-order-suggestion", "Ostatní zákazníci také nakoupili").insertAfter($extrasWrap);
        }

        additionalProducts.forEach(function(product) {
          $(product).addClass("active related-sm-screen-show");
        });
        $products.append(additionalProducts);

        return $wrap.html();
      });
    });
  }

  return { init };
})();

const SortProductsBlocks = (function() {
  const config = {
    selector: ".products-additional,.products-related"
  };

  function isInStock($p) {
    return !!$($p).find(".availability:contains(Skladem)").length;
  }

  function sortProductBlock($block) {
    const $products = $block.children(".product");
    if(!$products.length)
      return;

    $products.each(function(i) {
      $(this).data("index", i);
    });
    [].sort.call($products, function(a, b) {
      const aInStock = isInStock(a), bInStock = isInStock(b);

      if(aInStock !== bInStock)
        return aInStock ? -1 : 1;

      return $(a).data("index") - $(b).data("index");
    });

    $block.append($products);
  }

  function processProductBlocks() {
    $(".products-block").filter(config.selector).each(function() {
      if(!tb.dom.oneTime(this, "SortProductsBlocks"))
        return;
      sortProductBlock($(this));
    });
  }

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      processProductBlocks();
    },
    render() {
      processProductBlocks();
    }
  });

  return { config, init };
})();

const SiteMsgTools = (function($h, $t) {
  const config = {
    fallbackLang: "cs",
    trans: {
      cs: {
        days: n => `${n} ${tb.common.pluralize(n, "den", "dny", "dní")}`,
        hours: n => `${n} ${tb.common.pluralize(n, "hodina", "hodiny", "hodin")}`,
        minutes: n => `${n} ${tb.common.pluralize(n, "minuta", "minuty", "minut")}`,
        seconds: n => `${n} ${tb.common.pluralize(n, "sekunda", "sekundy", "sekund")}`,

        daysShort: n => `${n}d`,
        hoursShort: n => `${n}h`,
        minutesShort: n => `${n}min`,
        secondsShort: n => `${n}s`,

        and: "a",
      },
      sk: {
        days: n => `${n} ${tb.common.pluralize(n, "deň", "dni", "dní")}`,
        hours: n => `${n} ${tb.common.pluralize(n, "hodina", "hodiny", "hodin")}`,
        minutes: n => `${n} ${tb.common.pluralize(n, "minúta", "minúty", "minút")}`,
        seconds: n => `${n} ${tb.common.pluralize(n, "sekunda", "sekundy", "sekúnd")}`,

        daysShort: n => `${n}d`,
        hoursShort: n => `${n}h`,
        minutesShort: n => `${n}min`,
        secondsShort: n => `${n}s`,

        and: "a",
      }
    },
  };

  const join = (arr, sep, lastSep = sep) => (arr.length > 1 ? [arr.slice(0, -1).join(sep), ...arr.slice(-1)] : arr).join(lastSep);
  const pad2 = s => String(s).padStart(2, "0");

  function formatTime(sec, format) {
    const s = sec % 60;
    sec = Math.floor(sec / 60);
    const m = sec % 60;
    sec = Math.floor(sec / 60);
    const h = sec;
    const hDay = sec % 24;
    sec = Math.floor(sec / 24);
    const d = sec;

    // 42h 06min 08s
    if(format === 0)
      return `${pad2(h)}h ${pad2(m)}min ${pad2(s)}s`;

    // 1 den, 10 hodin, 15 minut, 10 sekund
    else if(format === 1) {
      const parts = [];
      if(d > 0)
        parts.push(t.days(d));
      if(parts.length || hDay > 0)
        parts.push(t.hours(hDay));
      if(parts.length || m > 0)
        parts.push(t.minutes(m));
      if(parts.length || s > 0)
        parts.push(t.seconds(s));
      return join(parts, ", ", ` ${t.and} `);

      // 1 den, 10:15:10
    } else if(format === 2) {
      const parts = [];
      if(d > 0)
        parts.push(t.days(d));
      parts.push(`${pad2(hDay)}:${pad2(m)}:${pad2(s)}`);
      return parts.join(", ");

      // 1d 10h 15min 10s
    } else if(format === 3) {
      const parts = [];
      if(d > 0)
        parts.push(t.daysShort(d));
      parts.push(t.hoursShort(hDay));
      parts.push(t.minutesShort(m));
      parts.push(t.secondsShort(s));
      return parts.join(" ");
    }
  }

  function toggleEl($el, visible) {
    let { $pl } = $el.data();
    if($pl?.length && visible) {
      $pl.after($el).remove();
      $el.data({ $pl: null });
    } else if(!$pl?.length && !visible) {
      $el.after($pl = $(document.createComment(""))).detach();
      $el.data({ $pl });
    }
  }

  function updateToggle($el) {
    const { from, to, debug } = $el.data();
    let visible = true;
    if(debug) {
      visible = tb.config.noCache;
    } else {
      const now = new Date;
      if(from && new Date(from) > now)
        visible = false;
      if(to && new Date(to) < now)
        visible = false;
    }
    toggleEl($el, visible);
  }

  function updateCountdown($el) {
    const { to: toStr, format = 0 } = $el.data();
    const to = new Date(toStr);
    if(!to)
      return;
    const now = new Date;
    if(to <= now) {
      $el.text("");
    } else {
      const diffSec = Math.round((to - now) / 1000);
      $el.text(formatTime(diffSec, format));
    }
  }

  let t;
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      t = tb.helpers.getStrings(config);

      let $siteMsg = $(".site-msg.information");
      if($siteMsg.length) {
        const $outerWrap = $siteMsg.find(".ji-site-msg-wrap");
        if($outerWrap.length) {
          const $newSiteMsg = $outerWrap.clone().addClass("site-msg information").html($siteMsg.contents());
          $siteMsg.after($newSiteMsg).remove();
          $outerWrap.after($outerWrap.contents()).remove(); // unwrap
          $siteMsg = $newSiteMsg;
        }

        const $countdowns = $siteMsg.find(".ji-site-msg-countdown");
        const $toggles = $siteMsg.find("[data-from],[data-to],[data-debug]");
        const $text = $siteMsg.find(".text").first();

        function update() {
          tb.dom.$each($toggles, updateToggle);
          tb.dom.$each($countdowns, updateCountdown);

          const isEmpty = $text.text().trim() === "";
          toggleEl($siteMsg, !isEmpty); // hide entire $siteMsg if empty

          const outerHeight = $siteMsg.prop("isConnected") ? ($siteMsg.outerHeight() || 0) : 0;
          document.body.style.setProperty("--ji-site-msg-height", outerHeight + "px");
        }
        setInterval(update, 1000);
        tb.hooks.hookAfterWindowResize(update);
        $siteMsg.addClass("ready");
      }
    },
  });

  return { config, init };
})(tb.$h, tb.$t);

var m = tb.modules;
m.ExternalRenderEvents.config.navstiveneProdukty = true;
m.ExternalRenderEvents.config.shoptetModal = true;
m.ExternalRenderEvents.init();
m.AdvancedOrderHooks.init();

m.RecentProductsLib.config.heading = tb.$h("h4", "Naposledy prohlížené");
m.RecentProductsLib.config.limit = 12;
m.RecentProductsLib.config.newestFirst = true;
m.RecentProductsLib.config.alwaysShowDetailBtn = true;
m.RecentProductsLib.config.maxLifetime = 72*3600*1000; // one hour
m.RecentProductsLib.config.maxDescriptionLength = 145;
m.RecentProductsLib.config.clonePriceSaveIntoBottom = false;
m.RecentProductsLib.config.pricesVersion = 2;
m.RecentProductsLib.init();

RecentProducts.init();
Watchdog.init();
TrackTopProducts.init();
AdvancedOrderProductInfo.init();
DetailPerCategoryContent.init();
LeftToFreeShippingFix.init();
AdvancedOrderMoreRelated.init();
SortProductsBlocks.init();
SiteMsgTools.init();

m.DetailHooks.init();

function freeShippingLeft() {
  let cartInfo = getShoptetDataLayer().cartInfo;
  if(cartInfo.freeShipping == true) {
    $("#transit-left-price-over").html('<div class="transit-left-price">Dopravu máte <strong>zdarma!</strong></div>');
  } else {
    if(cartInfo.leftToFreeShipping.priceLeft > 0) {
      $("#transit-left-price-over").html('<div class="transit-left-price">Objednejte ještě za <strong>' + cartInfo.leftToFreeShipping.formattedPrice + '</strong> a budete mít dopravu <strong>zdarma.</strong></div>');
    }
    else if (cartInfo.leftToFreeShipping.priceLeft == 0) {
      $("#transit-left-price-over").html('<div class="transit-left-price">Hoďte něco do košíku, ať máte dopravu zdarma!</div>');
    }
    else {
      $("#transit-left-price-over").html('<div class="transit-left-price">Dopravu máte <strong>zdarma!</strong></div>');
    }
  }
}

$(function() {
  const { $h, $t } = tb;

  /* Header */
  if(Fyft.t.phoneHoursStr)
      $h("span", `(${Fyft.t.phoneHoursStr})`).insertAfter(".top-navigation-bar .top-navigation-contacts .project-phone span");

  /*$(".top-navigation-bar .top-navigation-contacts .project-phone span:first-of-type").before("<span>+420</span>");*/
   if($(window).width() >= 767) {
     $("<span>Potřebuješ poradit?</span>").insertBefore(".top-navigation-contacts .project-phone");
     $(".top-navigation-contacts").insertAfter(".header-top>div:nth-of-type(2)");
   }
  $(".top-navigation-contacts .project-phone").addClass("ready");

  $("<li><a href='/oblibene/'>Oblíbené</a></li>").appendTo("body.mobile .top-navigation-bar .top-navigation-bar-menu.right");

  $("\
  <a href='/login/' class='navBtns loginBtn' id='loginBtn'>Přihlášení</a>\
  <a href='/registrace/' class='navBtns regBtn' id='regBtn'>Registrace</a>\
  ").insertBefore(".top-navigation-bar .dropdown");

  if($(window).width() < 767) {
    $(".top-navigation-bar .dropdown").insertAfter(".navigation-in ul");
    $(".navigation-in .dropdown>span").text("Zvolte měnu:");
  }
  $(".header-top").addClass("ready");

  $(".header-top .search input[type=search]").attr("placeholder", "Co hledáš? Kendama, Pokémon, Yoyo, …").val("").focus().blur();
  $(".header-top .search input[type=search]").addClass("show");

  $(".header-top .search input[type=search]").focus(function(){
    $("body").addClass("input-search-visible");

  }).blur(function(){
    $("body").removeClass("input-search-visible");
  })

  if ($(".top-nav-button-account").length)
    $("body").addClass("user-logged");

  $("body.in-vyhledavani #products-found").insertAfter("body.in-vyhledavani #search-group-categories");

  /* Init modules */

  Layout.init();
  Cart.init();
  Homepage.init();
  Catalog.init();
  Detail.init();
  Search.init();
  Post.init();

  /* Inserting */
  legacyLoadSnippets([
      "footer-bottom.html?=v3",
      "hp-blog.html?v=9",
      "instagram.html?v=8",
      "heureka.html?v=1",
      "thanks-page.html?v=9",
      "register-block.html?v=3",
      "empty-category.html?v=4",
      "login-block.html?v=2",
      "welcome-block.html?v=0.3",
  ], function(
    footerBottom, hpBlog, instagram, heureka, thanksPage, registerBlock, emptyCategory, loginBlock, welcomeBlock
  ) {

      $(thanksPage[0]).insertAfter(".in-dekujeme .content-inner .co-payment-method");

      $(".login-widget .popup-widget-inner h2").html("Přihlášení");
      $(".type-index .content-wrapper-in").addClass("ready");

      /* Footer */
      $(footerBottom[0]).insertBefore(".footer-bottom:not(.eet-message)");
      $("#footer #signature .title").replaceWith("<div class='title'>Vytvořil <a class='first' href='https://www.shoptet.cz/?utm_source=footer&utm_medium=link&utm_campaign=create_by_shoptet' target='_blank'>Shoptet</a> | Nakódoval <a href='https://www.eshopguru.cz/' target='_blank'>eshopGuru</a></div>");
      $("#footer #signature .image").insertBefore("#footer #signature .title .first");

      /* Instagram */
      $(instagram[0]).insertBefore("#footer");
      $(".custom-footer>div:nth-of-type(8)>div").insertAfter("#instagram-feed");

      /* Empty category & 404 */
      $(emptyCategory[0]).insertAfter("body.id-404 div[itemprop=about], body.type-category .category-perex.empty-content");
      $("body.id-404 #header .search, body.type-category #header .search").clone().appendTo(".empty-category__search");
      if ($("body.type-category").length) {
        var categoryBack = $("#navigation-1>a").attr("href");
        $("body.type-category .empty-category__middle .btn:nth-of-type(1)").attr("href", categoryBack);
      }


      /* Register page */
      // $("#register-form, #formLogin").wrapAll("<div class='register-wrap' />");
      // $(registerBlock[0]).appendTo(".register-wrap");
      $(loginBlock[0]).insertAfter(".popup-widget.login-widget .popup-widget-inner");
      // $("#register-form .submit-wrapper .btn").attr("value", "REGISTROVAT SE");
      // $("#register-form, #formLogin").addClass("ready");
      // $("body.in-registrace label[for=email]>span").text("E-mail");
      // $("body.in-registrace label[for=passwordAgain]>span").text("Heslo znovu");
      // $("body.in-registrace label[for=sendNewsletter]").text("Rovnou přihlásit k FYFT newsletteru");

      $("body.in-login h1").prependTo("body.in-login #formLogin");


      /* USPs */
      $(".custom-footer>div:nth-of-type(5)").clone().insertAfter("body.in-index .row.banners-row").wrapAll("<div class='usps'></div>");

      /* Newsletter */
      $(".custom-footer>div:nth-of-type(6)").clone().addClass("newsletter-block").insertAfter(".instagram-block");
      $("\
      <h2>INSPIRUJ SE. UŽÍVEJ.</h2>\
      <p>Každá cesta začíná prvním krokem. Chceš abychom ti s ním pomohli? Přihlaš se do našeho <strong>FYFTletteru</strong> a měj přehled o <strong>eventech, workshopech a návodech</strong>. Neboj, <a target='_blank' href='https://www.fyft.cz/zasady-zpracovani-osobnich-udaju/'>nespamujeme</a>.</p>\
      ").appendTo(".newsletter-block .newsletter-header");
      $(".newsletter-block form input").attr("placeholder", "Tvoje e-mailová adresa");

      $(".custom-footer>div:nth-of-type(9)").insertAfter(".newsletter-block .newsletter-header");
      $(".newsletter-block #formNewsletterWidget label[for=newsletterWidgetConsents31]").appendTo(".newsletter-block .ec-v-form-step-visible");
      $("input[type='email'].ec-v-forms-form-control").attr("placeholder", "Tvoje e-mailová adresa");



      /* Blog*/
      if ($("body.in-index"))
      {
        $(hpBlog[0]).insertAfter("body.in-index #products-2+.center.products");
        Layout.initBlogBlock();
      }
      if ($("body").hasClass("in-speedcube"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockSpeedcube();
      }
      if ($("body").hasClass("in-kendama"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockKendama();
      }
      if ($("body").hasClass("in-cardistry"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockCardistry();
      }
      if ($("body").hasClass("in-yoyo"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockYoyo();
      }
      if ($("body").hasClass("in-magic-the-gathering"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockMtg();
      }
      if ($("body").hasClass("in-discgolf"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockDiscgolf();
      }
      if ($("body").hasClass("in-frisbee"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockDiscgolf();
      }
      if ($("body").hasClass("in-drone-racing"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockDrone();
      }
      if ($("body").hasClass("in-juggle"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockJuggle();
      }
      if ($("body").hasClass("in-hry"))
      {
        $(hpBlog[0]).insertAfter("body.type-category .content-wrapper-in");
        Layout.initBlogBlockHry();
      }

      $(".type-posts-listing #newsWrapper").addClass("ready");
      Layout.workHours();

      /* HP categories */
      $(".custom-footer>div:nth-of-type(7)").clone().addClass("hp-categories-wrap").insertAfter("body.in-index .usps");
      $(".custom-footer>div:nth-of-type(7)").clone().addClass("hp-categories-wrap").appendTo(".hp-categories-here");

      /* USPs */
      $(".custom-footer>div:nth-of-type(5)").clone().insertBefore("body.type-category .instagram").wrapAll("<div class='usps'></div>");

      $(welcomeBlock[0]).insertAfter("body.in-index .homepage-box:not(.welcome-wrapper)");
      $(welcomeBlock[0]).insertAfter("body.in-index.mobile .hp-categories-wrap");

      $(document).trigger("customSnippetsLoaded");
  });

  /*$("body.type-page #content p, body.type-post #content p").each(function() {
    var author = $(this).text();
    var authorBlock = $("#footer .author-block[data-author='" + author + "']");

    if (authorBlock.length) {
      $(this).replaceWith (authorBlock);
    }
  });*/
  $("body.type-page #content p, body.type-post #content p").each(function() {
    var text = $(this).text();
    var authorMatch = text.match(/\[(.*?)\]/);

    if (authorMatch) {
      var author = authorMatch[0];
      var authorBlock = $("#footer .author-block[data-author='" + author + "']");

      if (authorBlock.length) {
        var newAuthorBlock = authorBlock.clone();
        newAuthorBlock.find("[data-author]").attr("data-author", author);
        $(this).replaceWith(newAuthorBlock);
      }
    }
  });


  /* HP */
  $("<div class='center products'></div>").insertAfter("#products-2.products-block");
  $("<div class='center products'></div>").insertAfter("#products-5.products-block");

  /* Footer */
  $("#footer .copyright").html("Copyright FYFT. Všechna práva vyhrazena.  Od roku 2016 💪");


  $(".cart-table .p-availability .show-tooltip:contains('Skladem')").addClass("in-stock");


  $(".p-info-wrapper .chevron-down-after").html("Detailní popis").appendTo(".p-short-description");
  $(".p-short-description").prependTo(".p-info-wrapper").addClass("visible");

  $(".p-final-price-wrapper").prependTo(".add-to-cart").addClass("visible");

  var $deliveryTimeLabel = $(".delivery-time-label");
  $(".delivery-time > .parameter-dependent").each(function() {
    var m = $(this).attr("class").match(/([0-9][0-9-]+)/);
    if(!m)
      return;
    var className = m[1];
    var $target = $(".p-basic-info-block .parameter-dependent." + className);

    if($target.find(".in-stock").length) {
      $target.append($deliveryTimeLabel.clone());
      $target.append($('<span class="delivery-time-custom"/>').html($(this).html()));
    }
  });


  $(".p-detail .products-related.products-block").insertAfter(".p-detail").removeClass("p-switchable");
  $(".products-related").wrapAll("<div class='rel-products'></div>");
  $("<div class='h4'>Související produkty</div>").prependTo(".rel-products");

  $(".p-detail #productsAlternative .products-block").insertAfter(".p-detail").removeClass("p-switchable");
  $(".products-alternative").wrapAll("<div class='sim-products'></div>");
  $("<div class='h4'>Podobné produkty</div>").prependTo(".sim-products");

  $(".products-alternative, .products-related").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    responsive: [
     {
       breakpoint: 1250,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 3
       }
     },
     {
       breakpoint: 999,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 2
       }
     },
     {
       breakpoint: 640,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 }).on("setPosition reinit", function(slick, currentSlide) {
    $(this).find(".slick-slide").removeClass("slick-screen-first slick-screen-last");
    $(this).find(".slick-track").each(function() {
      $(this).find(".slick-active").first().addClass("slick-screen-first");
      $(this).find(".slick-active").last().addClass("slick-screen-last");
    });
  });


  $(".in-index .products-block").slick({
     infinite: false,
     slidesToShow: 4,
     slidesToScroll: 1,
     dots: false,
     responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
   }).on("setPosition reinit", function(slick, currentSlide) {
      $(this).find(".slick-slide").removeClass("slick-screen-first slick-screen-last");
      $(this).find(".slick-track").each(function() {
        $(this).find(".slick-active").first().addClass("slick-screen-first");
        $(this).find(".slick-active").last().addClass("slick-screen-last");
      });
    });


  /* responsive */
  $(".custom-footer>div:not(.custom-footer__banner4) .item").each(function() {
    $(this).find("h4").click(function(){
      $(this).toggleClass("toggled");
      $(this).next().slideToggle();
    })
  });

  /* if category is "HRY" */
  if($("body.type-category .breadcrumbs #navigation-1:contains('HRY')").length) {
    $("body").addClass("game-category");
  }

  /* Type category breadcrumbs */
  if(!$("body.type-category .breadcrumbs #navigation-2").length) {
    $("body.type-category .breadcrumbs-wrapper").hide();
  }
  $(".breadcrumbs-wrapper").addClass("ready");

  /* FAQ signpost */
  if($("body.type-post .video-block").length)
    $("body").addClass("full-width");

  $(".video-block__item").click(function() {
    $(this).find(".video-block__inner").toggle();
    $(this).addClass("--active");
  });

  $(".in-krok-1 #checkoutSidebar .cart-content h4").click(function() {
    $(".in-krok-1 #checkoutSidebar .order-summary-inner .cart-items, .in-krok-1 #checkoutSidebar .order-summary-item:not(.price), .in-krok-1 #checkoutSidebar #shipping-billing-summary").toggle();
  });

  $(".in-krok-2 #checkoutSidebar .cart-content h4").click(function() {
    $(".in-krok-2 #checkoutSidebar .order-summary-inner .cart-items, .in-krok-2 #checkoutSidebar .order-summary-item:not(.price), .in-krok-2 #checkoutSidebar #shipping-billing-summary").toggle();
  });

  $("body.id-404 .phone-here, body.id-404 .email-here").empty();
  $(".top-navigation-contacts .project-phone").clone().appendTo("body.id-404 .phone-here");
  $(".top-navigation-contacts .project-email").clone().appendTo("body.id-404 .email-here");

  // /* Info msg */
  // if ($("body.desktop .site-msg.information").length) {
  //   var heightMsg = $(".site-msg.information").outerHeight();

  //   $(".popup-widget.cart-widget").css("margin-top", heightMsg);

  //   $(".site-msg.information .js-close-information-msg").click(function() {
  //     $(".popup-widget.cart-widget").css("margin-top", 0);
  //   });
  // }

  /* Cookies */
  $(".siteCookies .siteCookies__buttonWrap").appendTo(".siteCookies__links");

  /* Currency dropdown */
  if ($("#topNavigationDropdown:contains('CZK')").length)
    $("#topNavigationDropdown + .dropdown-menu").addClass("czk");
  if ($("#topNavigationDropdown:contains('EUR')").length)
    $("#topNavigationDropdown + .dropdown-menu").addClass("eur");

  freeShippingLeft();

  $(".type-category #content").addClass("ready");

  if (topMenuFits()) {
  hideTopMenuTrigger();
  } else {
    showTopMenuTrigger();
  }


});

})();
